var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FormControlLabel } from '@material-ui/core';
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n"])));
export var CheckBoxWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-evenly;\n"], ["\n  display: flex;\n  justify-content: space-evenly;\n"])));
export var CustomHelperText = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return (props.error ? 'red' : 'rgba(0, 0, 0, 0.54)'); });
export var CompactFormControlLabel = styled(FormControlLabel)({
    '&&': {
        marginLeft: 0,
        marginRight: 0
    }
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CustomFormikWeekCheckbox.Styles.js.map